/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { emailTemplatesUpdate } from '../../axios/emailTemplatesUpdate'
import type {
	EmailTemplatesUpdateError,
	EmailTemplatesUpdatePathParams,
	EmailTemplatesUpdateRequest,
	EmailTemplatesUpdateResponse,
} from '../../types/EmailTemplatesUpdate'

export const emailTemplatesUpdateMutationKey = () => [{ url: '/email-templates/:emailTemplate' }] as const

export type EmailTemplatesUpdateMutationKey = ReturnType<typeof emailTemplatesUpdateMutationKey>

export type EmailTemplatesUpdateVariables = {
	emailTemplate: EmailTemplatesUpdatePathParams['emailTemplate']
	data: EmailTemplatesUpdateRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/EmailTemplateController.php EmailTemplateController::update */
export function useEmailTemplatesUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		EmailTemplatesUpdateResponse,
		AxiosError<EmailTemplatesUpdateError>,
		EmailTemplatesUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: emailTemplatesUpdateMutationKey(),
		mutationFn: ({ emailTemplate, data }: EmailTemplatesUpdateVariables) =>
			emailTemplatesUpdate(emailTemplate, data, config).then(res => res.data),
		...options,
	})
}
